import { initializeSdk } from '@eventbrite/statsig';
import { AppProps } from './types';

const SAMPLE_RATE = 100;

export const getUserTrackingIDs = ({
    event,
    organizer,
    gaSettings,
}: AppProps) => ({
    eventId: event?.id,
    organizerId: organizer?.id,
    correlationId: gaSettings?.correlationId,
});

export const initializeStatsigSdk = async (app: AppProps) => {
    await initializeSdk({
        sampleRate: SAMPLE_RATE,
        user: {
            customIDs: getUserTrackingIDs(app),
            userID: app.user?.id,
        },
    });
};
